import React from 'react';
import MyCustomLogoIcon from './logo/softwareone-logo.png';

const LogoIcon = () => {
  return <img src={MyCustomLogoIcon} style={{ height: '12px', width: 'auto' }} alt="" />;
};

export default LogoIcon;
